export enum MISSING_PRODUCT_STEP {
  INITIAL = 'initial',
  SEARCH = 'search',
  OPEN_MODAL = 'openModal',
}
